import { Star } from "lucide-react"
import { Qualy } from "../../utils/qualy";
import { QualyProm } from "../../utils/qualy-prom";
import moment from "moment/moment";
import "moment/locale/es";
import perfil from "../../assets/img/usuario-negro.png";


export default function ReviewsSection({ reviews }: any) {
  const qualy = Qualy(reviews);

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Reseñas</h2>
      <div className="flex items-center gap-2 mb-6">
        <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" />
        <span className="text-lg font-semibold">{qualy.total["prom"]}</span>
        <span className="text-gray-600">({reviews.length} reseñas)</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {reviews.map((review : any) => (
          <div key={review.id} className="space-y-3">
            <div className="flex items-center gap-3">
              <img
                src={review.user[0].image || perfil}
                alt={`${review.user[0].firstname} ${review.user[0].lastname}}`}
                width={40}
                height={40}
                className="rounded-full"
              />
              <div>
                <div className="font-medium">{`${review.user[0].firstname} ${review.user[0].lastname}}`}</div>
                <div className="text-sm text-gray-600">{review.description}</div>
              </div>
            </div>
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className={`w-4 h-4 ${i < QualyProm(review) ? "fill-yellow-400 text-yellow-400" : "text-gray-300"}`}
                />
              ))}
              <span className="text-sm text-gray-600 ml-2">
                        {moment(review.created_at).locale("es").format("D [de] MMMM [de] YYYY")}</span>
            </div>
            <p className="text-gray-700 text-sm leading-relaxed">{review.description}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
